import React, { useState } from 'react';
import { Box, Container, useTheme, useMediaQuery } from '@mui/material';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import TransactionsTable from '../components/TransactionsTable';
interface TransactionViewProps {
  onLogout: () => void;
}
const TransactionView: React.FC<TransactionViewProps> = ({
  onLogout
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return <Box sx={{
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC'
  }} data-id="element-4472" data-mp="39uqez6ttsw9k">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} data-id="element-4473" data-mp="181am03a9n5bf" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="transactions" data-id="element-4474" data-mp="18225ifql9clc" />
      <Box component="main" sx={{
      flexGrow: 1,
      p: 3,
      width: {
        sm: `calc(100% - ${240}px)`
      },
      ml: 0,
      mt: 8
    }} data-id="element-4475" data-mp="1cy0zqjylloto">
        <Container maxWidth="xl" data-id="element-4476" data-mp="1ywenmz1wr9xn">
          <TransactionsTable searchQuery={searchQuery} data-id="element-4477" data-mp="1yvd0vxbj4z03" />
        </Container>
      </Box>
    </Box>;
};
export default TransactionView;